import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const DialogMDR = ({ trigger, data, statusCell }) => {
  const [open, setOpen] = useState(false);
  const getMonthAndYear = (date) => {
    const monthNames = [
      'Januar',
      'Februar',
      'Mars',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Desember',
    ];
    return `${monthNames[new Date(date).getMonth()]} ${new Date(
      date
    ).getFullYear()}`;
  };

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="flex flex-col gap-2 sm:gap-4 items-start sm:max-w-[425px]">
        <DialogTitle>Detaljer om forespørsel</DialogTitle>
        <div>
          <p className="text-muted-foreground sm:text-sm text-[12px]">
            Adresse forespørselen gjelder
          </p>
          <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
            {data.propertyAddress}
          </p>
        </div>
        <div>
          <p className="text-muted-foreground sm:text-sm text-[12px]">
            Navn på bedriften
          </p>
          <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
            {data.organizationName}
          </p>
        </div>
        <div>
          <p className="text-muted-foreground sm:text-sm text-[12px]">
            Forespørsel sendt
          </p>
          <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
            {getMonthAndYear(data.createdAt)}
          </p>
        </div>
        <div>
          <p className="text-muted-foreground sm:text-sm text-[12px]">
            Jobben er utført i
          </p>
          <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
            {new Date(data.jobDate).getFullYear()}
          </p>
        </div>
        {data.organizationEmailAddress && (
          <div>
            <p className="text-muted-foreground sm:text-sm text-[12px]">
              Epost
            </p>
            <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
              {data.organizationEmailAddress}
            </p>
          </div>
        )}
        {data.initialDescription && (
          <div>
            <p className="text-muted-foreground sm:text-sm text-[12px]">
              Beskrivelse av jobben
            </p>
            <p className="text-card-foreground sm:text-base text-[14px] font-semibold">
              {data.initialDescription}
            </p>
          </div>
        )}
        <div className="border border-muted" />
        <div className="flex flex-col items-start">
          <div className="flex">
            <h3 className="text-card-foreground sm:text-base text-[14px] font-semibold">
              Status
            </h3>
            <div className="flex items-center col-span-2 border rounded-xl py-0.5 px-2.5 ml-[6px] text-xs font-semibold">
              {statusCell}
            </div>
          </div>
          <p className="sm:text-base text-[14px] text-foreground">
            Håndverkeren har mottatt forespørselen din. Hvis du ikke mottar svar
            innen 7 dager purrer vi automatisk.
          </p>
        </div>
        <Button
          className="border"
          variant="ghost"
          type="button"
          onClick={() => setOpen(false)}
        >
          Lukk
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DialogMDR;
